import { createReducer, on } from '@ngrx/store';
import * as sedEventsActions from '../actions/sed-events.actions';

export interface SedEventsState {
    sedEvents: any[];
    error: any;
  }

export const initialState: SedEventsState = {
  sedEvents: [],
  error: null
};

export const sedEventsReducer = createReducer(
  initialState,
  on(sedEventsActions.loadSedEventsSuccess, (state, { sedEvents }) => ({...state, sedEvents, error: null})),
  on(sedEventsActions.loadSedEventsFailure, (state, { error }) => ({...state, error, loading: false})),

);
